import React from "react";
import { cn } from "@/libs/utils";
import Image from "next/image";

interface BlurBgOverlayProps {
  src: string;
  alt?: string;
  children: React.ReactNode;
  blurLevel?: string;
  overlayClass?: string;
  className?: string;
}

/*
 backgorund img blur components
 */
export const BlurBgOverlay = ({
  src,
  alt = "Image",
  children,
  blurLevel = "bg-white/15", // blurLevel속성 : bg-white/0 transparent - bg-white/100 : white
  overlayClass = "backdrop-blur-2xl",
  className = "",
}: BlurBgOverlayProps) => {
  return (
    <div
      className={cn(
        `relative overflow-hidden px-4 py-8 shadow-lg md:px-6 ${className}`,
      )}
    >
      {/* background */}
      <div className={`absolute inset-0`}>
        <Image
          src={src}
          alt={alt as string}
          className="object-cover"
          quality={1}
          fill
        />
      </div>

      {/* overlay */}
      <div
        className={`absolute inset-0 ${blurLevel} ${overlayClass} transition-transform will-change-transform`}
      ></div>

      {/* contents */}
      <div className="relative z-20 text-white">{children}</div>
    </div>
  );
};
